<template>
  <div class="login-container-outer">
    <div class="login-container col-lg-5 col-8">
      <span class="login-bar"></span>
      <div class="login-header">
        <h1>Portal | Sign In</h1>
        <div class="login-help text-muted" v-if="!loginError">
            Use your Helium API credentials
        </div>
        <div class="login-error" v-if="loginError">
            {{ loginError }}
        </div>
      </div>
      <form>
        <div class="form-group">
          <label class="col-5 col-form-label">Environment</label>
          <div class="input-group">
            <model-select :options="environmentOptions" v-model="selectedEnvironmentOption" placeholder="Please select an environment"></model-select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-5 col-form-label">Username</label>
          <div class="input-group">
            <input class="form-control" type="text" id="username" placeholder="Username"
               v-model="username" required="required" autocomplete="username" autofocus>
          </div>
        </div>
        <div class="form-group">
          <label class="col-5 col-form-label">Password</label>
          <div class="input-group">
            <input class="form-control" type="password" placeholder="Password" id="password" v-model="password" required="required" autocomplete="password">
          </div>
        </div>
        <button class="btn btn-md btn-info btn-block login login-submit" type="button"
          :disabled="!$parent.loading && !$parent.environment"
          v-on:click="signInBtn">
          <span v-if="!$parent.loading"><i class="fas fa-sign-in-alt"></i> Sign In</span>
          <span v-if="$parent.loading"> Logging in ...</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
  import { modal } from 'vue-strap'
  import { ModelSelect } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'
  export default {
    components: {
      modal,
      ModelSelect
    },
    data () {
      return {
        username: null,
        password: null,
        loginError: null,
        selectedEnvironmentOption: {
          value: '',
          text: ''
        }
      }
    },
    methods: {
      signInBtn: function () {
        if (!this.username) {
          this.loginError = 'Please enter your Helium API username'
          return
        } else if (!this.password) {
          this.loginError = 'Please enter your Helium API password'
          return
        }
        this.signIn(this.username, this.password)
      },
      signIn: function (usernameParam, passwordParam) {
        let vm = this
        var config = {
          credentials: {
            userName: usernameParam,
            password: passwordParam
          },
          baseUrl: vm.$parent.environment.baseUrl
        }
        vm.$parent.loading = true
        vm.axios.post(vm.$parent.baseUrl + '/portal-backend/api/apps', config)
          .then(function (response) {
            vm.$parent.username = usernameParam
            vm.$parent.password = passwordParam
            vm.$parent.apps = response.data
            vm.$parent.loading = false
          })
          .catch(function (error) {
            console.log(error)
            if (error.response.status === 401) {
              vm.loginError = 'Either the username or password is incorrect'
            } else {
              vm.loginError = 'Error logging in: ' + error.response.statusText + ' (' + error.response.status + ')'

              if (error.response.responseText) {
                vm.loginError += ' ' + error.response.responseText
              }
            }
            vm.$parent.loading = false
          })
      }
    },
    created () {
      let vm = this
      vm.$parent.loading = true
      vm.axios.get(vm.$parent.baseUrl + '/portal-backend/api/environments')
        .then(function (response) {
          vm.$parent.loading = false
          vm.$parent.environments = response.data.filter(function (env) {
            if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'production-dev') {
              return env.name.toLowerCase() !== 'localhost'
            } else {
              vm.$parent.environment = env
              return env.name.toLowerCase() === 'localhost'
            }
          })
        })
        .catch(function (error) {
          vm.$parent.loading = false
          vm.loginError = 'Error fetching environments: ' + error.response.statusText + ' (' + error.response.status + ')'
          if (error.response.responseText) {
            vm.loginError += ' ' + error.response.responseText
          }
        })

      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) {
          vm.signInBtn()
        }
      })
    },
    computed: {
      environmentOptions: function () {
        let vm = this
        let result = []
        if (vm.$parent.environments) {
          vm.$parent.environments.forEach(function (element) {
            var option = { value: element, text: element.name }
            result.push(option)
          })
        }
        return result
      }
    },
    watch: {
      'selectedEnvironmentOption': function (newValue) {
        this.$parent.environment = newValue.value
      }
    }
  }
</script>

<style scoped>

    .login-container-outer {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: url(/static/images/blur-background.jpg) round;
        overflow-y: scroll;
    }

    .login-container {
        padding: 60px 50px 50px 50px;
        background-color: #F7F7F7;
        margin: 60px auto 0;
        border-radius: 8px;
        overflow: hidden;
        border: #bcbcbc 1px solid;
        min-height: 650px;
    }

    .login-bar {
        background: #2196f3;
        position: absolute;
        right: 0;
        left: 0;
        color: white;
        top: 0;
        padding: 3px;
    }

    .login-container h1 {
        text-align: center;
        color: #4c4c4c;
    }

    .login-container input[type=submit] {
        width: 100%;
        display: block;
        margin-bottom: 10px;
        position: relative;
    }

    .login-container input[type=text], input[type=password] {
        height: 44px;
        width: 100%;
        margin-bottom: 10px;
        -webkit-appearance: none;
        background: #fff;
        border: 1px solid #d9d9d9;
        border-top: 1px solid #c0c0c0;
        /* border-radius: 2px; */
        padding: 0 8px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .login-submit {
        border: 0;
        font-weight: 600;
        font-stretch: expanded;
        text-transform: uppercase;
        color: #fff;
        text-shadow: 0 1px rgba(0, 0, 0, 0.1);
    }

    .login-header {
        padding-top: 40px;
        padding-bottom: 40px;
        text-align: center;
    }

    .login-error {
        color: red;
    }

    .fa-invisible {
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// SignIn.vue?522eb8d8